<template>
  <div>
    <h2>一、导言：</h2>
    <p>
      欢迎您使用协同宝平台及服务！
    </p>
    <p>
      本协议是由您（以下简称“您”）与协同宝平台（以下简称“协同宝”）所订立的协议，本协议自您确认接受之时起或自您使用协同宝及服务的行为发生之时起（以时间在先者为准）生效。
    </p>
    <p>
      本协议将对您使用本软件及服务的行为产生法律约束力,如果您安装、使用软件将视为您已经知悉、理解并接受本协议的全部内容。
      因此，请您务必审慎阅读、充分理解各条款的内容，特别是免除或者限制责任的条款、争议解决和法律适用条款等(如果您是未满18周岁的未成年人，审阅时应由法定监护人陪同,并特别注意未成年人使用条款)。
      如果您不同意本协议的任意内容，或者无法准确理解本协议条款的解释，请不要进行任何后续操作。否则，您的使用及任何操作行为，均视为已接受本协议约束。
    </p>
    <h2>二、服务范围</h2>
    <p>
      1、协同宝向您提供的应用下载、安装、更新等主体服务是免费的；
    </p>
    <p>
      2、为了向您提供有效的服务，协同宝需要链接互联网资源，具体流量费用标准，您需自行向运营商了解相关资费信息，并自行承担相关费用。
    </p>
    <h2>三、软件使用</h2>
    <p>
      1、您可以用协同宝官方网站获得本软件，也可以从第三方网站或渠道获取本软件；
    </p>
    <p>
      2、如果您从未经公司授权的其他渠道获取本软件或与本软件名称相同的安装程序，我们无法保证该软件是否可以正常使用，并对与此给您造成的损失不予负责；
    </p>
    <p>
      3、我们可能为不同的终端设备开发了不同的软件版本，您应当根据实际情况选择下载合适的版本进行安装。由于您未正确安装合适的软件版本所带来的风险及损失，我们不承担任何责任。
    </p>
    <h2>四、行为及内容规范</h2>
    <p>您在使用协同宝及服务过程中，禁止实施包括但不限于以下行为：</p>
    <p>
      1、利用本软件及服务从事反对宪法所确定的基本原则的行为；
    </p>
    <p>
      2、利用本软件及服务从事危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的行为；
    </p>
    <p>
      3、利用本软件及服务从事损害国家荣誉和利益的行为；
    </p>
    <p>
      4、利用本软件及服务从事煽动民族仇恨、民族歧视，破坏民族团结的行为；
    </p>
    <p>
      5、利用本软件及服务从事破坏国家宗教政策，宣扬邪教和封建迷信的行为；
    </p>
    <p>
      6、利用本软件及服务从事谣言，扰乱社会秩序，破坏社会稳定的行为；
    </p>
    <p>
      7、利用本软件及服务从事淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的行为；
    </p>
    <p>
      8、利用本软件及服务从事侮辱或者诽谤他人，侵害他人合法权益的行为；
    </p>
    <p>
      9、利用本软件及服务上传任何病毒，木马，或者蠕虫等危害网络健康的行为；
    </p>
    <p>
      10、制作、发布、传播用于窃取协同宝及他人专属信息、财产、保密信息的软件；
    </p>
    <p>
      11、利用本软件批量发表、传送、传播广告信息及垃圾信息；
    </p>
    <p>
      12、利用本软件发表、传送、传播、储存侵害他人知识产权、商业秘密权等合法权利的行为；
    </p>
    <p>
      13、其他以任何不合法的方式、为任何不合法的目的、或以任何与本协议不一致的方式使用本软件和协同宝提供的其他服务。
    </p>
    <h2>五、关于账号</h2>
    <p>
      如果您同意以其真实身份注册成为协同宝的用户，您应当遵守如下内容：
    </p>
    <p>
      1、保证所提供的个人身份资料信息真实、完整，依据法律规定和本协议约定对所提供的不实信息承担相应的法律责任和不利的法律后果。
      您不应将其账号、密码转让或出借予他人使用。如您发现其账号遭他人非法使用，应立即通知协同宝。
      因黑客行为或您的保管疏忽导致账号、密码遭他人非法使用，协同宝不承担任何法律明确规定以外的责任。
    </p>
    <p>
      2、协同宝有权要求您提供并审查，您在注册所提供的企业信息是否真实，并采取必要的技术与管理等措施保障您账号的安全、有效。
    </p>
    <p>
      3、您有义务妥善保管您的账号及密码，严格按照本协议的约定正确、安全地使用您账号及密码。
      您因为自身原因造成密码遗失、账号被盗而给自身和他人民事权利造成损害的，由您自行承担相应责任，协同宝不承担法律责任。
    </p>
    <p>
      4、您发现所分配的账号或密码被他人非法使用或有使用异常的情况的，应及时根据协同宝公布的方式通知协同宝，并提供与原始注册人相一致的个人有效身份信息。
      协同宝在核实您所提供的个人有效身份信息后，将尽可能为您维护自身合法权利提供必要协助。
    </p>
    <h2>六、知识产权</h2>
    <p>
      1、协同宝提供的软件（包括但不限于软件中所含的任何图像、照片、动画、录像、录音、音乐、文字和附加程序、随附的帮助材料）的一切权利均属于该软件的著作权人，
      未经该软件的著作权人许可，您不得对该软件进行反向工程（reverse engineer）、反向编译（decompile）或反汇编（disassemble）。
    </p>
    <h2>七、用户信息保护</h2>
    <p>
      保护您个人信息是协同宝的一项重要原则，我们将会采取合理的措施保护您的个人信息，并对相关信息采用专业加密存储与传输方式，保障您个人信息的安全。
      有关用户个人信息保护详情参见《隐私政策》，您使用本服务应已了解并接受相关的《隐私政策》。
    </p>
    <h2>八、免责声明</h2>
    <p>
      1、协同宝有权利改善或更正本服务任何部分之任何疏漏、错误。
    </p>
    <p>
      2、协同宝不保证（包括但不限于）：
    </p>
    <p>
      （1）提供的应用软件和服务适合您的使用要求；
    </p>
    <p>
      （2）网络服务不受干扰，及时、安全、可靠或不出现错误，包括黑客入侵，网络中断，电信问题及其他不可抗力等；
    </p>
    <p>
      （3）对于因不可抗力或协同宝不能控制的原因造成的网络服务中断或其它缺陷，协同宝不承担任何法律明确规定以外的责任，但将尽力减少因此而给您造成的损失和影响。
    </p>
    <h2>九、协议修改</h2>
    <p>
      1、本协议项下的服务由协同宝随时更新，更新后的协议将代替原协议条款，如果您不接受修改后的协议条款，您有权选择停止使用服务；一旦您继续使用服务，则表示您已接受经修改的协议条款。
      当您与协同宝就本协议发生争议时，应以最新版本的服务协议为准；
    </p>
    <p>
      2、协同宝所提供的服务存在因包括不可抗力、计算机病毒或黑客攻击、系统不稳定、您所在位置、通信线路、协同宝自身运营调整等因素造成的服务中断或不能满足您要求的风险；
    </p>
    <p>
      3、您与协同宝均有权随时终止本协议，协同宝不承担任何责任。
    </p>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
h2{
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  margin: 5px 0;
}
p{
  text-indent: 1.5rem;
  line-height: 20px;
}
</style>
